/* Core & libraries */
import React, { useState, useEffect } from "react";

/* Helpers, constants, custom methods, internal libraries */
import { breakpoints } from "../constants/breakpoints";

/* Components */
/* Styles */

export const useIsMobile = () => {
  const [width, setWidth] = useState(window.innerWidth);

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }
  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    }
  }, []);

  return width <= breakpoints.md;
}

